import { Button, ButtonProps, Label } from '@atoms/index';
import { NavigationButtonProps, NavigationButtons } from '@molecules/*';
import { Phone } from '@phosphor-icons/react';

interface CallUsTemplateProps {
  title: string;
  contentBody?: string | React.ReactNode;
  callButton?: ButtonProps;
  buttonPrevious: NavigationButtonProps;
  buttonNext: NavigationButtonProps;
}

export const CallUsTemplate = ({
  title,
  contentBody,
  callButton,
  buttonPrevious,
  buttonNext,
}: CallUsTemplateProps) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="mt-[25px] ">
        <Label text={title} className="text-brand-primary" isTitle={true} />
      </div>
      <div>{contentBody}</div>
      {callButton ? (
        <div className="mobile:flex hidden">
          <Button
            id="call-button"
            iconRight={<Phone aria-label="Phone icon" />}
            isExternalLink={true}
            href={callButton.href}
            {...callButton}
          />
        </div>
      ) : null}
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </div>
  );
};
